export const en = {
    'column-title-conversion': 'Conversion',
    'column-title-cpa': 'CPA, {currency}',
    'column-title-percent-conversion': 'conversion rate, %',
    'goals-statistics': 'Statistics by goals'
};
